import { downloadFileFromS3 } from "utils/function";


export const downloadRouteDataFilesInBatches = async (items, batchSize = 10) => {
    const results = [];

    for (let i = 0; i < items.length; i += batchSize) {
        const batch = items.slice(i, i + batchSize);
        const batchResults = await Promise.all(
            batch.map(async (item) => {
                try {
                    return await downloadFileFromS3(`traffic_monitoring_route_data/${item.routeDataKey}`)
                } catch (error) {
                    console.error(`Error downloading route data for ${item.routeDataKey}:`, error);
                    return null;
                }
            })
        );
        results.push(...batchResults);
    }

    return results;
}

export const LEVEL = {
    normal: 1,
    caution: 2,
    warning: 3
}

export const retrieveTrafficMonitoringRouteData = (trafficMonitoringRoutes, sensorMapping, generalSetting) => {
    const results = [];
    const setting = generalSetting.trafficMonitoring;
    for (const route of trafficMonitoringRoutes) {
        const {trafficDirections} = route;
        // Compare current time with daytime/nighttime settings
        const currentTime = new Date().toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: false,
            timeZone: 'Asia/Tokyo'
        });
        let timeOfDay = 'daytime';
        // Handle nighttime period that may span midnight
        const nightStart = setting.nighttimeStart;
        const nightEnd = setting.daytimeStart;
        if (nightStart < nightEnd) {
            if (currentTime >= nightStart && currentTime < nightEnd) {
                timeOfDay = 'nighttime';
            }
        } else {
            if (currentTime >= nightStart || currentTime < nightEnd) {
                timeOfDay = 'nighttime';
            }
        }
        // Determine route level based on sensor data and thresholds
        // If any sensor exceeds warning threshold, route is warning
        // Else if any sensor exceeds caution threshold, route is caution
        // Else route is normal (not displayed)
        // Accumulate popup messages for sensors that exceed thresholds
        const popupMessages = [];
        let trafficLevel = LEVEL.normal;
        for (const direction of trafficDirections) {
            let minTrafficSetup = Infinity;
            let directionLevel = LEVEL.normal;
            for (let i = 0; i < direction.cameraSettings.length; i++) {
                const cameraSetting = direction.cameraSettings[i];
                // Determine thresholds based on time of day
                const {cameraId, scenarioId, daytimeCaution, daytimeWarning, nighttimeCaution, nighttimeWarning } = cameraSetting;
                const camera = sensorMapping[cameraId];
                // Skip if cameraFeature or trafficVolumeFeature is disabled
                if (!camera?.data?.cameraFeature || !camera?.data?.trafficVolumeFeature) continue;
                let warningThreshold = Number(daytimeWarning);
                let cautionThreshold = Number(daytimeCaution);
                if (timeOfDay === 'nighttime') {
                    warningThreshold = Number(nighttimeWarning);  
                    cautionThreshold = Number(nighttimeCaution);
                }
                // Check sensor data against thresholds
                if (camera) {
                    const trafficVolume = camera.data.lastTrafficVolume ? camera.data.lastTrafficVolume[`count_${scenarioId}`] || 0 : 0;
                    if (warningThreshold > 0 && trafficVolume < warningThreshold) {
                        directionLevel = LEVEL.warning;
                        minTrafficSetup = Math.min(minTrafficSetup, warningThreshold);
                        continue;
                    }
                    if (cautionThreshold > 0 && trafficVolume < cautionThreshold) {
                        directionLevel = Math.max(directionLevel, LEVEL.caution);
                        minTrafficSetup = Math.min(minTrafficSetup, cautionThreshold);
                    }
                }
            }
            if ([LEVEL.caution, LEVEL.warning].includes(directionLevel))
                popupMessages.push(`${direction.directionName} ${directionLevel === LEVEL.warning ? '警報' : '注意'}(${minTrafficSetup}台未満)`);
            trafficLevel = Math.max(trafficLevel, directionLevel);
        }
        if (trafficLevel === LEVEL.normal) continue;
            results.push({
                positions: route.routeData.coordinates,
                color: trafficLevel === LEVEL.warning ? setting.warningColor : setting.cautionColor,
                messages: popupMessages,
                placeId: `traffic_monitoring_${route.routeId}`,
            });
    }
    return results;
}